// Validates REACT_APP_SOU_SOU_URL (the Sou-Sou site origin used by the promo button).
// Accepts https URLs, and http only for localhost; no user info, no whitespace. Anything else (unset, malformed,
// javascript:, data:, http on a real host...) returns null so the Sou-Sou half is not rendered.
// eslint-disable-next-line no-control-regex
const FORBIDDEN = /[\s\u0000-\u001f\u007f-\u009f\\]/

export const getSouSouUrl = (value = process.env.REACT_APP_SOU_SOU_URL) => {
  if (typeof value !== 'string' || !value || FORBIDDEN.test(value)) return null
  let url
  try {
    url = new URL(value)
  } catch (error) {
    return null
  }
  if (url.username || url.password) return null
  const isLocalhost = url.hostname === 'localhost'
  if (url.protocol !== 'https:' && !(url.protocol === 'http:' && isLocalhost)) return null
  return `${url.origin}${url.pathname.replace(/\/+$/, '')}/`
}
